import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./users_style.css";
import { FaUndo } from "react-icons/fa";

function DeletedUsers ({ setUpdateTrigger, updateTrigger }) {

    const [deletedUsers, setDeletedUsers] = useState([]);

    const getRoleId = (roleId) => {
        switch(roleId){
            case 1:
                return 'Administrador';
            case 2:
                return 'Super Admin';
            case 3:
                return 'Usuario';
            default:
                return 'Desconocido';
        }
    };

    const getAreaId = (areaId) => {
        switch(areaId){
            case 1:
                return '1 A';
            case 2:
                return '2 B';
            case 3:
                return '3 C';
            case 4:
                return '4 D';
            case 5:
                return '5 E';
            case 6:
                return '6 F';
            case 7:
                return '7 G';
            case 8:
                return '8 H';
            case 9:
                return '9 I';
            case 10:
                return '10 J';
            case 11:
                return '11 K';
            default:
                return '-';
        }
    };

    const getDeletedUsers = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/deleted`, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                },
            });
            if (res.status === 200) {
                setDeletedUsers(res.data.data);
            } else {
                Swal.fire("Error", "Hubo un error al obtener los datos eliminados", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    const restoreUser = async (id) => {
        try {
            const result = await Swal.fire({
                title: "¿Estás seguro?",
                text: "¿Quieres restaurar este Usuario?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: "Sí, restaurar",
                denyButtonText: "No, cancelar",
                reverseButtons: true,
                buttonsStyling: true,
            });

            if (result.isConfirmed) {
                const response = await axios.put(`${process.env.REACT_APP_URL_BACKEND}/api/v1/users/restore/${id}`, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                    },
                });

                Swal.fire("¡Restaurado!", "El usuario ha sido restaurado.", "success");
                setUpdateTrigger(!updateTrigger);
                getDeletedUsers();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Cancelado");
            }
        } catch (error) {
            Swal.fire("Error", "Hubo un error", "error");
        }
    };

    useEffect(() => {
        getDeletedUsers();
    }, [updateTrigger]);

    return (
        <div className='table-responsive'>
            <h3 className="mb-4">Usuarios Eliminados</h3>
            <table className="table table-inverse table-hover table-striped table-bordered dataTable no-footer" role="grid">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nombre</th>
                        <th>Apellido</th>
                        <th>Correo Electrónico</th>
                        <th>Permisos</th>
                        <th>Área</th>
                        <th>Creado</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {deletedUsers.map((user) => (
                        <tr key={user.id} data-master-id={user.id}>
                            <td>{user.id}</td>
                            <td>{user.first_name}</td>
                            <td>{user.last_name}</td>
                            <td>{user.email}</td>
                            <td>{getRoleId(user.role_id)}</td>
                            <td>{getAreaId(user.area_id)}</td>
                            <td>
                                <relative-time datetime={user.created_at} lang="es" />
                            </td>
                            <td>
                                <FaUndo className='restoreButton' onClick={() => { restoreUser(user.id) }} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

}

export default DeletedUsers;